import * as ACTION from '../Redux.constants';

export function setLevel(payload) {
  return {
    type: ACTION.SET_LEVEL,
    payload,
  };
}

export function setChapter(payload) {
  return {
    type: ACTION.SET_CHAPTER,
    payload,
  };
}

export function setCollapse(payload) {
  return {
    type: ACTION.SET_COLLAPSE,
    payload,
  };
}

export function cscqSelectOption(payload) {
  return {
    type: ACTION.CSCQ_SELECT_OPTION,
    payload,
  };
}

export function cscqSubmit(payload) {
  return {
    type: ACTION.CSCQ_SUBMIT,
    payload,
  };
}

export function mscqSelectOption(payload) {
  return {
    type: ACTION.MSCQ_SELECT_OPTION,
    payload,
  };
}

export function mscqSubmit(payload) {
  return {
    type: ACTION.MSCQ_SUBMIT,
    payload,
  };
}

export function gdndqSetSequence(payload) {
  return {
    type: ACTION.GDNDQ_SET_SEQUENCE,
    payload,
  };
}

export function gdndqSubmit(payload) {
  return {
    type: ACTION.GDNDQ_SUBMIT,
    payload,
  };
}

export function dndqSetSequence(payload) {
  return {
    type: ACTION.DNDQ_SET_SEQUENCE,
    payload,
  };
}

export function dndqSubmit(payload) {
  return {
    type: ACTION.DNDQ_SUBMIT,
    payload,
  };
}

export function ddqSetOption(payload) {
  return {
    type: ACTION.DDQ_SET_OPTION,
    payload,
  };
}

export function ddqSubmit(payload) {
  return {
    type: ACTION.DDQ_SUBMIT,
    payload,
  };
}

export function setDesignTab(payload) {
  return {
    type: ACTION.DESIGN_SET_TAB,
    payload,
  };
}

export function viewThreeDrop(payload) {
  return {
    type: ACTION.VIEW_THREE_DROP,
    payload,
  };
}

export function viewThreeSetStep(payload) {
  return {
    type: ACTION.VIEW_THREE_SET_STEP,
    payload,
  };
}

export function viewThreeRemoveStep(payload) {
  return {
    type: ACTION.VIEW_THREE_REMOVE_STEP,
    payload,
  };
}

export function viewThreeHint(payload) {
  return {
    type: ACTION.VIEW_THREE_HINT,
    payload,
  };
}

export function viewThreeComplete(payload) {
  return {
    type: ACTION.VIEW_THREE_COMPLETE,
    payload,
  };
}

export function viewFourDrop(payload) {
  return {
    type: ACTION.VIEW_FOUR_DROP,
    payload,
  };
}

export function viewFourSetStep(payload) {
  return {
    type: ACTION.VIEW_FOUR_SET_STEP,
    payload,
  };
}

export function viewFourRemoveStep(payload) {
  return {
    type: ACTION.VIEW_FOUR_REMOVE_STEP,
    payload,
  };
}

export function viewFourHint(payload) {
  return {
    type: ACTION.VIEW_FOUR_HINT,
    payload,
  };
}

export function viewFourComplete(payload) {
  return {
    type: ACTION.VIEW_FOUR_COMPLETE,
    payload,
  };
}

export function startTour(payload) {
  return {
    type: ACTION.START_TOUR,
    payload,
  };
}

export function incrementTour(payload) {
  return {
    type: ACTION.INCREMENT_TOUR,
    payload,
  };
}

export function endTour(payload) {
  return {
    type: ACTION.END_TOUR,
    payload,
  };
}

export function setModal(payload) {
  return {
    type: ACTION.SET_MODAL,
    payload,
  };
}

export function showModal(payload) {
  return {
    type: ACTION.SHOW_MODAL,
    payload,
  };
}

export function undoModal(payload) {
  return {
    type: ACTION.UNDO_MODAL,
    payload,
  };
}
